import React from 'react';
import TableAction from '../TableAction';
import { Filter, FilterStateMap } from '../types';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Box, Button, Grid, makeStyles, Popover, Theme } from '@material-ui/core';
import DateFilter from './DateFilter';
import InputFilter from './InputFilter';
import OptionFilter from './OptionFilter';
import NumericFilter from './NumericFilter';

const useStyles = makeStyles((theme: Theme) => ({
  actions: {
    position: 'absolute',
    bottom: theme.spacing(1),
    left: 0, right: 0,
    padding: theme.spacing(0, 2),
    marginTop: theme.spacing(2),
    '& > *:not(:first-child)': {
      marginLeft: theme.spacing(1)
    }
  },
  componentRoot: {
    maxHeight: 200,
    overflow: 'auto'
  }
}))

const filterTypeToComponent = {
  date: DateFilter,
  input: InputFilter,
  options: OptionFilter,
  numeric: NumericFilter
} as const;

type FilterProps = Filter & {
  state: FilterStateMap[FilterProps['type']],
  setState: (newState: Partial<FilterProps['state']>) => void;
}

const FilterComponent = (props: FilterProps) => {
  const {type, setState, ...rest} = props;

  const filterRef = React.useRef<HTMLElement | null>(null);
  const [open, setOpen] = React.useState<boolean>(false);
  // Indication from lower component as to whether validation was successful
  const [valid, setValid] = React.useState<boolean>(false);
  // Indicate to lower component that validation is pending before popover closes
  const [validate, setValidate] = React.useState<boolean>(false);

  const classes = useStyles();

  const handleClose = () => {
    setValid(false);
    setValidate(false);
    setOpen(false);
    filterRef.current = null;
  }

  React.useEffect(() => {
    if(valid) {
      handleClose();
    }
  }, [valid])
  
  const Component = filterTypeToComponent[type];

  return <>
    <TableAction
      color={rest.state && Object.keys(rest.state).length ? 'primary':'default'}
      onClick={(e) => {
        e.stopPropagation();
        filterRef.current = e.currentTarget;
        setOpen(true);
      }}
      size='small'
      title='Filter'
    >
      <FilterListIcon fontSize='small' />
    </TableAction>
    <Popover
      anchorEl={filterRef.current}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
      onClick={e => e.stopPropagation()}
      onClose={() => setValidate(true)}
      open={open}
    >
      <Box
        minWidth={270}
        p={2}
        position='relative'
      >
        <Grid
          container
          direction='column'
        >
          <Grid
            className={classes.componentRoot}
            item
          >
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Component
              setState={setState}
              setValid={setValid}
              validate={validate}
              {...rest} />
          </Grid>
          <Box marginTop={'45px'}>
            <Grid
              className={classes.actions}
              container
              justifyContent='flex-end'>
              <Button
                onClick={() => {setState({}); handleClose()}}>Reset</Button>
              <Button
                color='primary'
                onClick={() => setValidate(true)}
                variant='contained'>Ok</Button>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </Popover>
  </>
};

export default FilterComponent;